import { LevelingSideGridModule } from './leveling-side-grid/leveling-side-grid.module';
import { DxDataGridModule, DxButtonModule, DxSelectBoxModule, DxCheckBoxModule } from 'devextreme-angular';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LevelingComponent } from './leveling.component';

@NgModule({
  declarations: [LevelingComponent],
	exports: [LevelingComponent],
  imports: [
    CommonModule,
		
		LevelingSideGridModule,

		DxDataGridModule,
		DxButtonModule,
		DxSelectBoxModule,
		DxCheckBoxModule,
  ]
})
export class LevelingModule { }
